import React, { useEffect, useState } from 'react'
import { errorSchema, utils } from 'helper'
import { CityDropdownForTrip, CommonModal, CustomSelect } from 'components'
import StorageService from 'utils/StorageServices/StorageServices'
import { fetchConsignorDetailsData } from '_services/accountsServices/consignorServices'
import { getCityLocationList } from '_services/accountsServices/cityLocationService'
import toast from 'react-hot-toast'
import AddLocationModal from 'modals/AddLocationModal'

const formObj = {
    party: {},
    from_city: {},
    to_city: {},
}

const AddPickUpDrop = (props) => {
    let { isOpen, nextModal, closeModal, addButtonAction, showPrefield, secondSubmit, isAddLrLater, filledLocation = {} } = props;

    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);
    const [consignorList, setConsignorList] = useState([]);
    const [openLoction, setOpenLoction] = useState(false)
    const [typeOfDropdown, setTypeOfDropdown] = useState({
        type: "",
        index1: '',
        index: ""
    })

    useEffect(() => {
        setFormValue((s) => ({
            ...s,
            party: isOpen?.party
        }))
    }, [isOpen])

    const fetchFromCity = async (search, page, limit) => {
        const res = await getCityLocationList({
            countryCode: "IN",
            stateCode: "",
            offset: page,
            limit,
            search,

        });
        if (res?.responseCode === 200) {
            const list = res?.data?.all_cities.map((c) => ({ ...c, _id: c.name, label: `${c.name}, ${c.stateName}` }))

            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            toast.error(res?.responseMessage);
        }
    };

    const validateForm = () => {
        const errors = {};

        // Validate from_city
        if (!formValue?.from_city?.value) {
            errors.from_city = "Please select pickup location";
        }

        // Validate to_city
        if (!formValue?.to_city?.value) {
            errors.to_city = "Please select drop location";
        }

        

        return errors;
    };


    const handleSubmit = async (event) => {
        event.preventDefault();
        const validationErrors = validateForm();
        if (Object.keys(validationErrors).length === 0) {
            setLoading(true);
            try {
                await secondSubmit(formValue);
                closeModal(false);
                // Reset form after successful submission
                setFormValue(formObj);
                setFormError({});
            } catch (error) {
                toast.error('Failed to submit form');
            } finally {
                setLoading(false);
            }
        } else {
            setFormError(validationErrors);

        }
    }



    const propsLrModalInhance = {
        ...props,
        isLoadding: loading,
        disabled: loading,
        onSubmit: (e) => handleSubmit(e),

    }

    useEffect(() => {
        if (consignorList?.length > 0 && showPrefield) {
            setFormValue((s) => ({
                ...s,
                party: consignorList?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?._id,
                    }
                })[0],
            }))
        }
    }, [consignorList, showPrefield])

    const buttonActionHandler = () => {
        addButtonAction(true);
        closeModal(false)
    }

    const handleInputChange = (data, key) => {
        setFormValue((s) => ({
            ...s,
            [key]: {
                ...data,
                label: data?.label,
                value: data?._id,
            }
        }))
        setFormError((s) => ({
            ...s,
            [key]: "",
        }))
    }

    const addNewItemHandler = (e, type) => {

        setOpenLoction(true)
        setTypeOfDropdown((i) => ({
            ...i,
            type,

        }))

        // setModalZIndex(999)
    }

    const callBackDataMap = async (data) => {
        if (!typeOfDropdown?.type) return;

        const { type, index1 } = typeOfDropdown;

        // Format the selected city data
        const formattedData = {
            ...data,
            _id: data.name, // or use a better unique ID if available
            label: `${data.name}, ${data.stateName}`,
            value:data.name
        };


        setFormValue((s) => ({
            ...s,
            [type]: formattedData
        }))
        setFormError((s) => ({
            ...s,
            [type]: "",
        }))

    };

    let gmapLocate = {
        isOpen: openLoction,
        closeModal: (e) => {
            setOpenLoction(false)

        },
        modalMainClass: "_dashCommon_Modal _mdModalLoction",
        modalTitle: 'Add Location',
        submitTitle: 'Add Location',
        callBackDataMap: callBackDataMap
    };

    return (
        <div>
            <CommonModal {...propsLrModalInhance}>
                <div className='addLr_body' style={{ display: "flex", flexDirection: "column", gap: "25px" }}>
                    <CityDropdownForTrip
                        key={`fromLoction`}
                        label="From City * "
                        placeholder="Select a city"
                        fetchData={fetchFromCity}
                        isAddButton={true}
                        //   addButtonAction={(e) => addNewItemHandler(e, "from", index1, "")}
                        pageSize={20}
                        onChange={(data) => handleInputChange(data, "from_city")}
                        selectedItem={formValue?.from_city}
                        error={!!formError.from_city}
                        errorMessage={formError.from_city}
                        addButtonAction={(e) => addNewItemHandler(e, "from_city")}
                    />
                    <CityDropdownForTrip
                        key={`toLoction`}
                        label="To City * "
                        placeholder="Select a city"
                        fetchData={fetchFromCity}
                        isAddButton={true}
                        addButtonAction={(e) => addNewItemHandler(e, "to_city")}
                        onChange={(data) => handleInputChange(data, "to_city")}
                        selectedItem={formValue?.to_city}
                        error={!!formError.to_city}
                        errorMessage={formError.to_city}

                    />
                </div>
            </CommonModal>
            {openLoction && <AddLocationModal {...gmapLocate} />}
        </div>
    )
}

export default AddPickUpDrop
